/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_Source_HelpInputs */

const en_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose whether to generate dialogue via automatic transcription or use an existing Event Group from your project.`)
};

const fr_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez si vous souhaitez générer le dialogue par transcription automatique ou utiliser un groupe d'événements existant de votre projet.`)
};

const de_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entscheiden Sie, ob der Dialog per automatischer Transkription generiert werden soll oder ob Sie eine bestehende Ereignisgruppe aus Ihrem Projekt verwenden möchten.`)
};

const it_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli se generare il dialogo tramite trascrizione automatica o utilizzare un gruppo di eventi esistente dal tuo progetto.`)
};

const ru_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите, следует ли генерировать диалоги с помощью автоматической транскрипции или использовать существующую группу событий из вашего проекта.`)
};

const es_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige si deseas generar el diálogo mediante transcripción automática o utilizar un grupo de eventos existente de tu proyecto.`)
};

const zh_cn2_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择是通过自动转录生成对话，还是使用项目中现有的事件组。`)
};

const ja_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動文字起こしによって対話を生成するか、プロジェクト内の既存のイベントグループを使用するかを選択してください。`)
};

const hi_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप चाहें तो स्वचालित प्रतिलेखन के माध्यम से संवाद उत्पन्न करने का विकल्प चुन सकते हैं या अपने प्रोजेक्ट से किसी मौजूदा इवेंट ग्रुप का उपयोग कर सकते हैं।`)
};

const pt_pt2_dialogue_source_help = /** @type {(inputs: Dialogue_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha se deseja gerar o diálogo por meio de transcrição automática ou usar um Grupo de Eventos existente do seu projeto.`)
};

/**
* | output |
* | --- |
* | "Choose whether to generate dialogue via automatic transcription or use an existing Event Group from your project." |
*
* @param {Dialogue_Source_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_source_help = /** @type {((inputs?: Dialogue_Source_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_Source_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_source_help(inputs)
	if (locale === "de") return de_dialogue_source_help(inputs)
	if (locale === "it") return it_dialogue_source_help(inputs)
	if (locale === "ru") return ru_dialogue_source_help(inputs)
	if (locale === "es") return es_dialogue_source_help(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_source_help(inputs)
	if (locale === "ja") return ja_dialogue_source_help(inputs)
	if (locale === "hi") return hi_dialogue_source_help(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_source_help(inputs)
	return en_dialogue_source_help(inputs)
});